(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velomora-article"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-vm-copy]');
    if (!button) return;

    const label = button.querySelector('.vm-article__copy-text');
    if (!label) return;

    try {
      await navigator.clipboard.writeText(button.dataset.vmCopy);
    } catch (error) {
      return;
    }

    if (button.dataset.original) return;
    button.dataset.original = label.textContent;
    label.textContent = button.dataset.copied;
    button.classList.add('is-copied');

    setTimeout(() => {
      label.textContent = button.dataset.original;
      button.classList.remove('is-copied');
      delete button.dataset.original;
    }, 2000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velomora-body-shape-calculator"] && !Shopify.designMode) return;
  try {
    
  // Body shape from three measurements, in inches, evaluated in this order:
  //
  //   1. hourglass   bust and hips within `balance` of each other, and a waist
  //                  at least `bustGap` under the bust or `hipGap` under the hips
  //   2. apple       waist within `appleGap` of BOTH bust and hips, and no
  //                  defined waist by the test above
  //   3. pear        hips more than `balance` wider than the bust
  //   4. inverted    bust more than `balance` wider than the hips
  //   5. rectangle   everything else
  //
  // The thresholds arrive from the section settings, which are also what the
  // rule sentences on the page are printed from, so the page and the maths
  // cannot disagree. Defaults (2, 9, 10, 4) put the hourglass test on the same
  // footing as the calculators that rank for this query, so someone who checks
  // her numbers in two places gets the same word back. The apple and balance
  // tests are ours: they exist because the advice underneath them differs.
  //
  // Order matters. Apple is tested before pear and inverted triangle so that a
  // body whose waist is as wide as everything else is not filed under whichever
  // of bust or hips happens to win by two inches.
  function classify(m, rules) {
    const balanced = Math.abs(m.bust - m.hip) <= rules.balance;
    const waistDefined = m.bust - m.waist >= rules.bustGap || m.hip - m.waist >= rules.hipGap;

    if (balanced && waistDefined) return 'hourglass';
    if (!waistDefined && m.waist >= m.bust - rules.appleGap && m.waist >= m.hip - rules.appleGap) {
      return 'apple';
    }
    if (m.hip - m.bust > rules.balance) return 'pear';
    if (m.bust - m.hip > rules.balance) return 'inverted';
    return 'rectangle';
  }

  class VmBodyShape {
    constructor(root) {
      this.root = root;
      this.panel = root.querySelector('[data-vm-panel]');
      this.form = root.querySelector('[data-vm-bodyshape]');
      this.result = root.querySelector('[data-vm-result]');
      this.config = JSON.parse(root.querySelector('[data-vm-bodyshape-config]').textContent);

      // The translate filter HTML-escapes, so an apostrophe arrives as &#39; and
      // would render literally through textContent. Decode once, via a textarea,
      // which parses entities without executing markup.
      const holder = document.createElement('textarea');
      Object.keys(this.config.strings).forEach((key) => {
        holder.innerHTML = this.config.strings[key];
        this.config.strings[key] = holder.value;
      });

      this.answers = Array.from(root.querySelectorAll('[data-vm-answer]'));

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.find();
      });
      const restart = root.querySelector('[data-vm-restart]');
      if (restart) restart.addEventListener('click', () => this.reset());
    }

    get unit() {
      const checked = this.form.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : 'in';
    }

    round(value) {
      return Math.round(value * 10) / 10;
    }

    // Measurements are held in inches because the thresholds are. Everything
    // shown back to her is in the unit she picked.
    show(inches) {
      const strings = this.config.strings;
      if (this.unit === 'cm') return Math.round(inches * 2.54) + ' ' + strings.cm;
      const value = this.round(inches);
      return value + ' ' + (value === 1 ? strings.inch : strings.inches);
    }

    fail(message) {
      const error = this.root.querySelector('[data-vm-error]');
      error.textContent = message;
      error.hidden = false;
      this.result.hidden = true;
      this.panel.classList.remove('is-resolved');
    }

    reset() {
      this.form.reset();
      this.result.hidden = true;
      this.root.querySelector('[data-vm-error]').hidden = true;
      this.answers.forEach((answer) => {
        answer.hidden = true;
      });
      this.panel.classList.remove('is-resolved');
      this.panel.scrollIntoView({
        block: 'start',
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
      const first = this.form.querySelector('[data-vm-bust]');
      if (first) first.focus({ preventScroll: true });
    }

    // On the mobile layout the form is hidden once there is a result, which
    // shortens the page and leaves scroll anchoring to pick a position. Put the
    // panel back at the top of the viewport deliberately instead.
    settleScroll() {
      if (getComputedStyle(this.form).display !== 'none') return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.panel.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
    }

    find() {
      const strings = this.config.strings;
      const toInches = (value) => (this.unit === 'cm' ? value / 2.54 : value);
      const raw = {
        bust: parseFloat(this.form.querySelector('[data-vm-bust]').value),
        waist: parseFloat(this.form.querySelector('[data-vm-waist]').value),
        hip: parseFloat(this.form.querySelector('[data-vm-hip]').value),
      };

      const missing = Object.keys(raw).some((key) => !isFinite(raw[key]) || raw[key] <= 0);
      if (missing) {
        this.fail(strings.errorMissing);
        return;
      }

      const m = {
        bust: toInches(raw.bust),
        waist: toInches(raw.waist),
        hip: toInches(raw.hip),
      };

      // Guards against centimetres typed while inches is selected, and the
      // reverse. Deliberately wide: this is a typo check, not a judgement about
      // which bodies are allowed an answer.
      const outOfRange =
        m.bust < 26 || m.bust > 70 || m.waist < 20 || m.waist > 70 || m.hip < 24 || m.hip > 80;
      if (outOfRange) {
        this.fail(strings.errorRange);
        return;
      }

      this.root.querySelector('[data-vm-error]').hidden = true;
      this.render(m, classify(m, this.config.rules));
    }

    // One sentence on what decided it, built from her own numbers rather than
    // from the thresholds, because the difference is the thing she can check.
    reasonFor(m, key) {
      const strings = this.config.strings;

      if (key === 'pear') {
        return strings.reasonPear.replace('[gap]', this.show(m.hip - m.bust));
      }
      if (key === 'inverted') {
        return strings.reasonInverted.replace('[gap]', this.show(m.bust - m.hip));
      }

      const widest = Math.max(m.bust, m.hip);
      if (key === 'apple') {
        if (m.waist >= widest) return strings.reasonAppleWidest;
        return strings.reasonApple.replace('[gap]', this.show(widest - m.waist));
      }

      const template = key === 'hourglass' ? strings.reasonHourglass : strings.reasonRectangle;
      return template
        .replace('[gap]', this.show(Math.abs(m.bust - m.hip)))
        .replace('[waist_gap]', this.show(widest - m.waist));
    }

    render(m, key) {
      const strings = this.config.strings;

      let matched = false;
      this.answers.forEach((answer) => {
        const hit = answer.getAttribute('data-vm-key') === key;
        answer.hidden = !hit;
        if (hit) matched = true;
      });

      // A shape with no block still gets its working out. Nothing here depends
      // on the copy existing, so a deleted block costs the advice and the
      // products, not the answer.
      if (!matched && window.console) {
        console.warn('velomora: no body shape block for "' + key + '"');
      }

      this.root.querySelector('[data-vm-numbers]').textContent = strings.numbers
        .replace('[bust]', this.show(m.bust))
        .replace('[waist]', this.show(m.waist))
        .replace('[hip]', this.show(m.hip));
      this.root.querySelector('[data-vm-reason]').textContent = this.reasonFor(m, key);

      this.result.hidden = false;
      this.panel.classList.add('is-resolved');
      this.settleScroll();
    }
  }

  document.querySelectorAll('.vm-bodyshape').forEach((root) => new VmBodyShape(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velomora-bra-calculator"] && !Shopify.designMode) return;
  try {
    
  // Indian sizing, per Clovia's published chart: band is the underbust rounded
  // up to an even number plus four, and the cup runs from A at zero difference.
  // Transcribed from that chart and checked against all 100 of its cells, and it
  // reproduces their calculator (underbust 40, bust 48 -> 44E).
  //
  // This is NOT the UK/international method, where the band is the underbust
  // with nothing added and A starts at one inch. Same body, different label:
  // underbust 40 / bust 48 is 44E here and 40FF there.
  const CUPS = ['A', 'B', 'C', 'D', 'E', 'F'];

  // Pull cup letters out of a variant option label such as "Medium ( B-C cup )"
  // or "13cm ( D- D+ cup size )". Returns [] for labels that are not cup-based,
  // e.g. "8CM": those products are treated as fitting any size.
  function cupsInLabel(label) {
    const bracket = label.match(/\(([^)]+)\)/);
    const inner = (bracket ? bracket[1] : label).toUpperCase();
    if (inner.indexOf('CUP') === -1) return [];
    const found = [];
    const singles = inner.match(/\b([A-F])\b/g) || [];
    singles.forEach((letter) => found.push(letter));
    const range = inner.match(/\b([A-F]{1,2})\s*-\s*([A-F]{1,2})\b/);
    if (range) {
      const from = CUPS.indexOf(range[1]);
      const to = CUPS.indexOf(range[2]);
      if (from > -1 && to > -1) {
        for (let i = Math.min(from, to); i <= Math.max(from, to); i++) found.push(CUPS[i]);
      }
    }
    // "D+" means D and everything above it.
    if (/D\s*\+/.test(inner)) {
      for (let i = CUPS.indexOf('D'); i < CUPS.length; i++) found.push(CUPS[i]);
    }
    return found;
  }

  class VmBraCalculator {
    constructor(root) {
      this.root = root;
      this.panel = root.querySelector('[data-vm-panel]');
      this.form = root.querySelector('[data-vm-bracalc]');
      this.config = JSON.parse(root.querySelector('[data-vm-bracalc-config]').textContent);
      // The translate filter HTML-escapes, so an apostrophe arrives as &#39; and
      // would render literally through textContent. Decode once, via a textarea,
      // which parses entities without executing markup.
      const decode = (value) => {
        const holder = document.createElement('textarea');
        holder.innerHTML = value;
        return holder.value;
      };
      Object.keys(this.config.strings).forEach((key) => {
        this.config.strings[key] = decode(this.config.strings[key]);
      });

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.calculate();
      });
      const restart = root.querySelector('[data-vm-restart]');
      if (restart) restart.addEventListener('click', () => this.reset());
      this.wireFigureHighlight();
    }

    get unit() {
      const checked = this.form.querySelector('input[name="vm-unit"]:checked');
      return checked ? checked.value : 'in';
    }

    // Focusing or hovering a field lights the matching band, so "underbust"
    // stops being a word you have to interpret. All the visual work is CSS.
    wireFigureHighlight() {
      const set = (value) => this.panel.setAttribute('data-vm-highlight', value);
      this.root.querySelectorAll('[data-vm-field]').forEach((field) => {
        const which = field.getAttribute('data-vm-field');
        const input = field.querySelector('input');
        if (!input) return;
        input.addEventListener('focus', () => set(which));
        input.addEventListener('blur', () => set('none'));
        field.addEventListener('mouseenter', () => {
          if (!field.contains(document.activeElement)) set(which);
        });
        field.addEventListener('mouseleave', () => {
          if (!field.contains(document.activeElement)) set('none');
        });
      });
    }

    fail(message) {
      const error = this.root.querySelector('[data-vm-error]');
      error.textContent = message;
      error.hidden = false;
      this.root.querySelector('[data-vm-result]').hidden = true;
      const gps = this.root.querySelector('[data-vm-gps]');
      if (gps) gps.hidden = true;
      this.panel.classList.remove('is-resolved');
    }

    // On the mobile layout the form is hidden once there is a result, which
    // shortens the page and leaves the browser's scroll anchoring to pick a
    // position: it landed ~430px away. Put the panel back at the top of the
    // viewport deliberately instead. On desktop nothing is hidden and the result
    // appears alongside, so no scrolling is wanted.
    settleScroll() {
      const setup = this.root.querySelector('.vm-bracalc__setup');
      if (!setup || getComputedStyle(setup).display !== 'none') return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.panel.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
    }

    reset() {
      this.form.reset();
      this.root.querySelector('[data-vm-result]').hidden = true;
      this.root.querySelector('[data-vm-error]').hidden = true;
      const gps = this.root.querySelector('[data-vm-gps]');
      if (gps) gps.hidden = true;
      this.panel.classList.remove('is-resolved');
      this.panel.scrollIntoView({
        block: 'start',
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
      const first = this.form.querySelector('[data-vm-underbust]');
      if (first) first.focus({ preventScroll: true });
    }

    calculate() {
      const toInches = (value) => (this.unit === 'cm' ? value / 2.54 : value);
      const bustRaw = parseFloat(this.form.querySelector('[data-vm-bust]').value);
      const underbustRaw = parseFloat(this.form.querySelector('[data-vm-underbust]').value);
      const strings = this.config.strings;

      if (!isFinite(underbustRaw) || !isFinite(bustRaw) || underbustRaw <= 0 || bustRaw <= 0) {
        this.fail(strings.errorMissing);
        return;
      }

      const underbust = toInches(underbustRaw);
      const bust = toInches(bustRaw);

      if (bust < underbust) {
        this.fail(strings.errorBustSmaller);
        return;
      }
      // Guards against cm typed while inches is selected, and vice versa.
      if (underbust < 22 || underbust > 60) {
        this.fail(strings.errorRange);
        return;
      }

      const band = Math.ceil(underbust / 2) * 2 + 4;
      let cupIndex = Math.floor(bust - band);
      if (cupIndex < 0) cupIndex = 0;
      if (cupIndex > CUPS.length - 1) cupIndex = CUPS.length - 1;

      this.render(band, cupIndex);
    }

    sisterSizes(band, cupIndex) {
      const out = [];
      if (cupIndex + 1 <= CUPS.length - 1) out.push(`${band - 2}${CUPS[cupIndex + 1]}`);
      if (cupIndex - 1 >= 0) out.push(`${band + 2}${CUPS[cupIndex - 1]}`);
      return out;
    }

    // Show every product whose size options cover the calculated size: an exact
    // variant match, a cup-range match, or no size option at all.
    matchProducts(size, cup) {
      const wrap = this.root.querySelector('[data-vm-products]');
      if (!wrap) return;
      let shown = 0;
      this.root.querySelectorAll('[data-vm-product]').forEach((item) => {
        const raw = item.getAttribute('data-vm-sizes') || '';
        const labels = raw.split('|').filter(Boolean);
        // A product labelled 30A..40D is sized by band AND cup, so an exact
        // variant is the only thing that fits: falling back to a cup match
        // would recommend a 40D bra to a 44D. Cup-labelled products
        // ("Large ( D- D+ cup )") match on the letter. Anything else: one-size
        // products, or diameters like 8CM: fits everyone.
        const bandSized = labels.some((l) => /^\s*\d{2}\s*(AA|DD|FF|GG|[A-G])\s*$/i.test(l));
        let fits;
        if (!labels.length) {
          fits = true;
        } else if (labels.some((l) => l.replace(/\s+/g, '').toUpperCase() === size)) {
          fits = true;
        } else if (bandSized) {
          fits = false;
        } else {
          const cups = labels.reduce((acc, l) => acc.concat(cupsInLabel(l)), []);
          fits = cups.length ? cups.indexOf(cup) > -1 : true;
        }
        item.hidden = !fits;
        if (fits) shown++;
      });
      wrap.hidden = shown === 0;
    }

    // The preferred-source ask is only worth making once someone has a size in
    // hand, so it waits for the first result and then stays put.
    revealPreferredSource() {
      const gps = this.root.querySelector('[data-vm-gps]');
      if (gps) gps.hidden = false;
    }

    render(band, cupIndex) {
      const cup = CUPS[cupIndex];
      const size = `${band}${cup}`;

      this.root.querySelector('[data-vm-error]').hidden = true;
      this.root.querySelector('[data-vm-size]').textContent = size;
      this.root.querySelector('[data-vm-band]').textContent = String(band);
      this.root.querySelector('[data-vm-cup]').textContent = cup;

      const sisters = this.sisterSizes(band, cupIndex);
      this.root.querySelector('[data-vm-sisters]').textContent = sisters.length
        ? sisters.join('  ·  ')
        : this.config.strings.none;

      this.matchProducts(size, cup);

      this.root.querySelector('[data-vm-result]').hidden = false;
      this.revealPreferredSource();
      this.panel.classList.add('is-resolved');
      this.settleScroll();
    }
  }

  document.querySelectorAll('.vm-bracalc').forEach((root) => new VmBraCalculator(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velomora-gift-box"]) return;
  try {
    
  (() => {
    if (customElements.get('vm-gift-box')) return;

    const STORE_KEY = 'vm-giftbox-v1';
    const DEVICE_KEY = 'vm-giftbox-device';
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const randomInt = (max) => {
      const buf = new Uint32Array(1);
      window.crypto.getRandomValues(buf);
      return buf[0] % max;
    };

    const readStore = () => {
      try {
        return JSON.parse(localStorage.getItem(STORE_KEY)) || {};
      } catch (e) {
        return {};
      }
    };

    const writeStore = (data) => {
      try {
        localStorage.setItem(STORE_KEY, JSON.stringify({ ...readStore(), ...data }));
      } catch (e) {
        /* storage blocked: the gift still works for this page view */
      }
    };

    const deviceId = () => {
      try {
        let id = localStorage.getItem(DEVICE_KEY);
        if (!id) {
          id = window.crypto.randomUUID();
          localStorage.setItem(DEVICE_KEY, id);
        }
        return id;
      } catch (e) {
        return window.crypto.randomUUID();
      }
    };

    const track = (event, params) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...params });
    };

    class VmGiftBox extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-vm-gift-grid]');
        this.boxes = Array.from(this.querySelectorAll('[data-vm-gift-box]'));
        this.dialog = this.querySelector('.vm-gift__dialog');
        this.launcher = this.querySelector('[data-vm-gift-launcher]');
        this.busy = false;

        this.querySelectorAll('[data-vm-gift-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        this.querySelector('[data-vm-gift-shuffle]').addEventListener('click', () => this.shuffle());
        this.querySelector('[data-vm-gift-apply]').addEventListener('click', () => this.apply());
        this.querySelector('[data-vm-gift-copy]').addEventListener('click', (e) => this.copy(e.currentTarget));
        this.querySelector('[data-vm-gift-retry]').addEventListener('click', () => this.claimFor(this.pickedBox));
        this.boxes.forEach((box) => box.addEventListener('click', () => this.pick(box)));
        if (this.launcher) this.launcher.addEventListener('click', () => this.open('launcher'));
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.close();
        });

        const params = new URLSearchParams(window.location.search);
        const preview = params.get('vm_gift') === '1';
        if (preview) localStorage.removeItem(STORE_KEY);
        if (this.dataset.enabled !== 'true' && !preview) return;

        this.hidden = false;
        const store = readStore();

        if (store.won) {
          this.showWon(store.won, false);
          this.showLauncher(store.won.code);
          return;
        }

        // Default: never pops up on its own; a gift button waits on the page.
        if (this.dataset.autoOpen !== 'true') {
          this.showLauncher(null, true);
          this.nudgeTimer = setTimeout(() => this.launcher && this.launcher.classList.add('is-nudge'), 6000);
          return;
        }

        const cooldownMs = Number(this.dataset.cooldownDays || 0) * 86400000;
        if (!preview && store.dismissedAt && Date.now() - store.dismissedAt < cooldownMs) {
          this.showLauncher();
          return;
        }

        if (preview) {
          this.open('preview');
          return;
        }
        this.armTriggers();
      }

      armTriggers() {
        const fire = (source) => {
          if (this.triggered) return;
          this.triggered = true;
          document.removeEventListener('mouseout', onExit);
          this.open(source);
        };
        const delay = Number(this.dataset.delay || 0);
        if (delay > 0) this.timer = setTimeout(() => fire('timer'), delay * 1000);

        const onExit = (e) => {
          if (!e.relatedTarget && e.clientY <= 0) fire('exit_intent');
        };
        if (this.dataset.exitIntent === 'true' && window.matchMedia('(pointer: fine)').matches) {
          document.addEventListener('mouseout', onExit);
        }
      }

      open(source) {
        clearTimeout(this.timer);
        this.lastFocus = document.activeElement;
        this.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        if (this.launcher) this.launcher.hidden = true;
        clearTimeout(this.nudgeTimer);
        this.dialog.focus();
        track('vm_giftbox_open', { vm_gift_source: source });
      }

      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        const store = readStore();
        if (!store.won) writeStore({ dismissedAt: Date.now() });
        this.showLauncher(store.won && store.won.code, this.dataset.autoOpen !== 'true');
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      }

      showLauncher(code, always) {
        if (!this.launcher || (!always && this.dataset.showLauncher !== 'true')) return;
        if (code) this.querySelector('[data-vm-gift-launcher-text]').textContent = code;
        this.launcher.hidden = false;
      }

      setStep(step) {
        // Intro and pick share one footprint so the dialog does not jump.
        const actions = this.querySelector('[data-vm-gift-step="intro"]');
        actions.hidden = step === 'won';
        actions.classList.toggle('is-spacer', step === 'pick');
        this.querySelector('[data-vm-gift-step="won"]').hidden = step !== 'won';
        this.querySelector('[data-vm-gift-title-intro]').hidden = step !== 'intro';
        this.querySelector('[data-vm-gift-title-pick]').hidden = step !== 'pick';
        this.querySelector('[data-vm-gift-title-won]').hidden = step !== 'won';
        this.querySelector('[data-vm-gift-sub]').hidden = step === 'won';
        this.querySelector('[data-vm-gift-sub-intro]').hidden = step !== 'intro';
        this.querySelector('[data-vm-gift-sub-pick]').hidden = step !== 'pick';
      }

      async shuffle() {
        if (this.busy) return;
        this.busy = true;
        this.querySelector('[data-vm-gift-shuffle]').disabled = true;
        track('vm_giftbox_shuffle', {});

        this.boxes.forEach((box) => box.classList.add('is-closed'));
        await wait(reducedMotion() ? 0 : 650);

        // Each box keeps its offer as it moves, so the shuffle is real.
        const rounds = reducedMotion() ? 1 : 6;
        for (let r = 0; r < rounds; r += 1) {
          await this.moveRound(reducedMotion() ? 0 : 340);
        }

        this.setStep('pick');
        this.classList.add('is-picking');
        this.boxes.forEach((box) => {
          box.disabled = false;
          box.setAttribute('aria-label', 'Open this box');
        });
        this.busy = false;
      }

      async moveRound(duration) {
        const slots = Array.from(this.grid.children);
        const first = new Map(slots.map((slot) => [slot, slot.getBoundingClientRect()]));

        // Fisher-Yates on the DOM order.
        const order = slots.slice();
        for (let i = order.length - 1; i > 0; i -= 1) {
          const j = randomInt(i + 1);
          [order[i], order[j]] = [order[j], order[i]];
        }
        order.forEach((slot) => this.grid.appendChild(slot));

        if (!duration) return;
        slots.forEach((slot) => {
          const a = first.get(slot);
          const b = slot.getBoundingClientRect();
          slot.style.transition = 'none';
          slot.style.transform = `translate(${a.left - b.left}px, ${a.top - b.top}px)`;
        });
        this.grid.getBoundingClientRect();
        slots.forEach((slot) => {
          slot.style.transition = `transform ${duration}ms cubic-bezier(0.65, 0, 0.35, 1)`;
          slot.style.transform = '';
        });
        await wait(duration + 20);
        slots.forEach((slot) => {
          slot.style.transition = '';
        });
      }

      async pick(box) {
        if (!this.classList.contains('is-picking') || this.busy) return;
        this.busy = true;
        this.classList.remove('is-picking');
        this.boxes.forEach((b) => {
          b.disabled = true;
        });

        box.classList.remove('is-closed');
        box.classList.add('is-chosen');
        await wait(reducedMotion() ? 0 : 700);
        this.boxes.forEach((b) => {
          if (b === box) return;
          b.classList.remove('is-closed');
          b.classList.add('is-other');
        });

        this.pickedBox = box;
        track('vm_giftbox_pick', { vm_gift_offer: box.dataset.offer });
        await this.claimFor(box);
        this.busy = false;
      }

      // The code comes from the gift server only now: one per shopper.
      async claimFor(box) {
        const retry = this.querySelector('[data-vm-gift-retry]');
        retry.hidden = true;
        let data = null;
        if (this.dataset.testMode === 'true') {
          // Preview only: a sample code, no server call, not valid at checkout.
          await wait(400);
          this.showWon({ offer: box.dataset.offer, code: box.dataset.testCode || 'TEST-CODE', title: box.dataset.title,
            detail: box.dataset.detail, qty: Number(box.dataset.qty || 1) }, false);
          return;
        }
        try {
          const res = await fetch(this.dataset.claimUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ offer: box.dataset.offer, device: deviceId() }),
          });
          data = await res.json();
        } catch (e) {
          data = null;
        }

        if (!data || !data.ok || !data.code) {
          this.showError(box);
          return;
        }
        // A device that already has a gift gets that same gift back.
        const source = this.boxes.find((b) => b.dataset.offer === data.offer) || box;
        const won = {
          offer: data.offer,
          code: data.code,
          title: source.dataset.title,
          detail: source.dataset.detail,
          qty: Number(source.dataset.qty || 1),
        };
        writeStore({ won, wonAt: Date.now() });
        this.showWon(won, false);
      }

      showError(box) {
        this.querySelector('[data-vm-gift-result-title]').textContent = box.dataset.title;
        this.querySelector('[data-vm-gift-result-detail]').textContent = box.dataset.detail || '';
        this.querySelector('[data-vm-gift-error]').hidden = false;
        this.querySelector('[data-vm-gift-retry]').hidden = false;
        this.querySelector('[data-vm-gift-code-row]').hidden = true;
        this.querySelector('[data-vm-gift-apply]').hidden = true;
        this.setStep('won');
      }

      showWon(won, animate) {
        if (!animate) {
          this.boxes.forEach((b) => {
            b.classList.remove('is-closed', 'is-chosen', 'is-other');
            b.disabled = true;
            b.classList.add(b.dataset.offer === won.offer ? 'is-chosen' : 'is-other');
          });
        }
        this.querySelector('[data-vm-gift-error]').hidden = true;
        this.querySelector('[data-vm-gift-retry]').hidden = true;
        this.querySelector('[data-vm-gift-code-row]').hidden = false;
        this.querySelector('[data-vm-gift-apply]').hidden = false;
        this.querySelector('[data-vm-gift-result-title]').textContent = won.title;
        this.querySelector('[data-vm-gift-result-detail]').textContent = won.detail || '';
        this.querySelector('[data-vm-gift-code]').textContent = won.code;
        this.won = won;
        this.setStep('won');
      }

      async apply() {
        if (!this.won) return;
        const btn = this.querySelector('[data-vm-gift-apply]');
        btn.disabled = true;
        try {
          // Sets Shopify's discount_code cookie; the Shiprocket checkout
          // picks it up as the coupon when it opens.
          await fetch(`/discount/${encodeURIComponent(this.won.code)}`, { credentials: 'same-origin' });
        } catch (e) {
          /* the code is still shown so the shopper can enter it at checkout */
        }
        this.setQuantity(this.won.qty);
        this.querySelector('[data-vm-gift-applied]').hidden = false;
        writeStore({ appliedAt: Date.now() });
        track('vm_giftbox_apply', { vm_gift_offer: this.won.offer });
        setTimeout(() => this.close(), 1600);
      }

      setQuantity(qty) {
        if (!qty || qty < 2) return;
        const input = document.querySelector('[data-vm-qty]');
        const plus = document.querySelector('[data-vm-qty-plus]');
        if (!input || !plus) return;
        let guard = 5;
        while (Number(input.value) < qty && guard > 0) {
          plus.click();
          guard -= 1;
        }
      }

      async copy(btn) {
        try {
          await navigator.clipboard.writeText(this.won.code);
          btn.textContent = 'Copied';
          setTimeout(() => {
            btn.textContent = 'Copy';
          }, 1500);
        } catch (e) {
          /* clipboard blocked: the code stays visible on screen */
        }
      }
    }

    customElements.define('vm-gift-box', VmGiftBox);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velomora-neckline-finder"] && !Shopify.designMode) return;
  try {
    
  // Indian sizing, the same ladder the bra size calculator uses, so a cup letter
  // carried over from that page means the same thing here.
  const CUPS = ['A', 'B', 'C', 'D', 'E', 'F'];

  // Cup bands as they are typed in the theme editor: "A-B", "C", "D+", and
  // "D-D++" for anyone copying a product's own option label. A trailing plus
  // means that letter and everything above it.
  function cupsIn(text) {
    const raw = String(text || '')
      .toUpperCase()
      .replace(/\s+/g, '');
    if (!raw) return [];
    const letters = raw.match(/[A-F]/g) || [];
    if (!letters.length) return [];
    const first = CUPS.indexOf(letters[0]);
    if (first === -1) return [];

    if (raw.charAt(raw.length - 1) === '+') {
      return CUPS.slice(first);
    }
    if (letters.length > 1) {
      const last = CUPS.indexOf(letters[letters.length - 1]);
      if (last === -1) return [CUPS[first]];
      return CUPS.slice(Math.min(first, last), Math.max(first, last) + 1);
    }
    return [CUPS[first]];
  }

  // One rule per line in the outfit's setting:
  //
  //   A-B | butterfly | tape  | uplift
  //   D+  | tape      | butterfly |
  //
  // Columns are the cup band, the product to lead with, the alternative, and
  // optionally a different lead for someone who says she will be dancing. The
  // fourth column is how an outfit opts into that swap, so no rule changes
  // under anyone without being written down here.
  function parseRules(raw) {
    return String(raw || '')
      .split(';')
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => {
        const cells = line.split('|').map((cell) => cell.trim());
        return {
          cups: cupsIn(cells[0]),
          primary: (cells[1] || '').toLowerCase(),
          alt: (cells[2] || '').toLowerCase(),
          active: (cells[3] || '').toLowerCase(),
        };
      })
      .filter((rule) => rule.cups.length && rule.primary);
  }

  // One row per cup band in a solution's setting:
  //
  //   A-B | A-B
  //   D+  | D-D++
  //
  // The right hand side is a token to look for inside the product's own size
  // option, not the whole value, so "13" finds "13cm ( D- D+ cup size )" and
  // the merchant never retypes a label that the admin might reword.
  function parseSizes(raw) {
    return String(raw || '')
      .split(';')
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => {
        const cells = line.split('|').map((cell) => cell.trim());
        return {
          cups: cupsIn(cells[0]),
          token: (cells[1] || '').toUpperCase().replace(/\s+/g, ''),
        };
      })
      .filter((row) => row.cups.length && row.token);
  }

  // Each variant carries both forms: the maker's own wording, which is what she
  // is shown and what the product page will have selected, and a squashed copy
  // that the size token is matched against.
  function parseVariants(raw) {
    const out = [];
    String(raw || '')
      .split('~')
      .filter(Boolean)
      .forEach((pair) => {
        const at = pair.lastIndexOf('=');
        if (at < 1) return;
        const value = pair.slice(0, at);
        out.push({
          value: value,
          norm: value.toUpperCase().replace(/\s+/g, ''),
          id: pair.slice(at + 1),
        });
      });
    return out;
  }

  class VmNecklineFinder {
    constructor(root) {
      this.root = root;
      this.panel = root.querySelector('[data-vm-panel]');
      this.form = root.querySelector('[data-vm-neckline]');
      this.result = root.querySelector('[data-vm-result]');
      this.pool = root.querySelector('[data-vm-pool]');
      this.headline = root.querySelector('[data-vm-headline]');
      this.slots = {
        primary: root.querySelector('[data-vm-slot="primary"]'),
        alt: root.querySelector('[data-vm-slot="alt"]'),
      };
      this.config = JSON.parse(root.querySelector('[data-vm-neckline-config]').textContent);

      // The translate filter HTML-escapes, so an apostrophe arrives as &#39; and
      // would render literally through textContent. Decode once, via a textarea,
      // which parses entities without executing markup.
      const holder = document.createElement('textarea');
      Object.keys(this.config.strings).forEach((key) => {
        holder.innerHTML = this.config.strings[key];
        this.config.strings[key] = holder.value;
      });

      this.solutions = {};
      root.querySelectorAll('[data-vm-solution]').forEach((el) => {
        const key = el.getAttribute('data-vm-key');
        if (!key) return;
        this.solutions[key] = {
          el: el,
          sizes: parseSizes(el.getAttribute('data-vm-sizes')),
          variants: parseVariants(el.getAttribute('data-vm-variants')),
          url: el.getAttribute('data-vm-url') || '',
        };
      });

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.find();
      });
      const restart = root.querySelector('[data-vm-restart]');
      if (restart) restart.addEventListener('click', () => this.reset());
    }

    get wear() {
      const checked = this.form.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : 'easy';
    }

    fail(message) {
      const error = this.root.querySelector('[data-vm-error]');
      error.textContent = message;
      error.hidden = false;
      this.result.hidden = true;
      this.panel.classList.remove('is-resolved');
    }

    reset() {
      this.form.reset();
      this.result.hidden = true;
      this.root.querySelector('[data-vm-error]').hidden = true;
      this.panel.classList.remove('is-resolved');
      this.panel.scrollIntoView({
        block: 'start',
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
      const first = this.form.querySelector('[data-vm-outfit]');
      if (first) first.focus({ preventScroll: true });
    }

    // On the mobile layout the form is hidden once there is a result, which
    // shortens the page and leaves scroll anchoring to pick a position. Put the
    // panel back at the top of the viewport deliberately instead.
    settleScroll() {
      if (getComputedStyle(this.form).display !== 'none') return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.panel.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
    }

    find() {
      const strings = this.config.strings;
      const option = this.form.querySelector('[data-vm-outfit]').selectedOptions[0];
      const cup = this.form.querySelector('[data-vm-cup]').value;

      if (!option) {
        this.fail(strings.errorNoRule);
        return;
      }

      const rules = parseRules(option.getAttribute('data-vm-rules'));
      const rule = rules.find((item) => item.cups.indexOf(cup) > -1);

      // No row covers this cup, so there is no honest answer to give. Say so
      // rather than falling back to whichever row happens to be first.
      if (!rule) {
        this.fail(strings.errorNoRule);
        return;
      }

      const swapped = this.wear === 'active' && rule.active && rule.active !== rule.primary;
      const primaryKey = swapped ? rule.active : rule.primary;
      // Whatever the swap displaced is still worth showing, so it becomes the
      // alternative rather than disappearing.
      let altKey = rule.alt;
      if (swapped) altKey = rule.primary;
      if (altKey === primaryKey) altKey = '';

      const primary = this.solutions[primaryKey];
      if (!primary) {
        this.fail(strings.errorNoRule);
        return;
      }

      this.root.querySelector('[data-vm-error]').hidden = true;

      const answer = option.getAttribute('data-vm-answer') || '';
      this.headline.textContent = strings.headline
        .replace('[outfit]', answer)
        .replace('[cup]', cup);

      // Everything goes home first, so a card that was primary last time is not
      // left sitting in the alternative slot.
      this.root.querySelectorAll('[data-vm-solution]').forEach((el) => this.pool.appendChild(el));

      const note = option.getAttribute('data-vm-note') || '';
      this.place('primary', primary, cup, note, swapped ? strings.activeSwap : '');

      const alt = altKey ? this.solutions[altKey] : null;
      if (alt) {
        this.place('alt', alt, cup, '', '');
        this.slots.alt.hidden = false;
      } else {
        this.slots.alt.hidden = true;
      }

      this.result.hidden = false;
      this.panel.classList.add('is-resolved');
      this.settleScroll();
    }

    place(slot, solution, cup, note, swapNote) {
      const strings = this.config.strings;
      const el = solution.el;
      this.slots[slot].appendChild(el);

      const lines = [];
      if (swapNote) lines.push(swapNote);
      if (note) lines.push(note);
      el.querySelector('[data-vm-why]').textContent = lines.join(' ');

      const size = el.querySelector('[data-vm-size]');
      const cta = el.querySelector('[data-vm-cta]');
      const row = solution.sizes.find((item) => item.cups.indexOf(cup) > -1);
      const variant = row
        ? solution.variants.find((item) => item.norm.indexOf(row.token) > -1)
        : null;

      // Three states, and the middle one is the reason this is not a boolean.
      // A bra sized 30A to 40D is sized by band as well as cup, so a cup letter
      // alone cannot pick a variant: say that, rather than calling it one size
      // or preselecting something only half right.
      if (variant) {
        size.textContent = strings.sizePicked.replace('[size]', variant.value);
        cta.textContent = strings.cta;
        cta.href = solution.url + '?variant=' + variant.id;
      } else {
        size.textContent = solution.variants.length ? strings.sizeChoose : strings.sizeOnPage;
        cta.textContent = strings.ctaPlain;
        cta.href = solution.url;
      }
    }
  }

  document.querySelectorAll('.vm-neckline').forEach((root) => new VmNecklineFinder(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velomora-shapewear-finder"] && !Shopify.designMode) return;
  try {
    
  // Size rows come from the theme editor, one line per size:
  //
  //   S-M | 26-32 |
  //   L   | 33-38 |
  //
  // Second column is the waist range in inches, third the hip range, which is
  // optional because a garment can be sized on the waist alone. Rows read
  // smallest first, and a measurement that lands in a gap between two rows takes
  // the larger of them: with shapewear the size that still works is the bigger
  // one, which is what the size guide tells people too.
  function parseBands(raw) {
    return String(raw || '')
      .split(';')
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => {
        const cells = line.split('|').map((cell) => cell.trim());
        const range = (cell) => {
          const pair = String(cell || '').match(/(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)/);
          if (!pair) return null;
          return { min: parseFloat(pair[1]), max: parseFloat(pair[2]) };
        };
        return { label: cells[0], waist: range(cells[1]), hip: range(cells[2]) };
      })
      .filter((band) => band.label && band.waist);
  }

  function parseVariants(raw) {
    const out = {};
    String(raw || '')
      .split(',')
      .filter(Boolean)
      .forEach((pair) => {
        const parts = pair.split(':');
        if (parts.length === 2) out[parts[0].trim().toUpperCase()] = parts[1].trim();
      });
    return out;
  }

  // Index of the row a measurement belongs to, or one past the end when it is
  // larger than everything stocked. Null when there is nothing to measure against.
  function indexFor(bands, value, key) {
    if (!isFinite(value)) return null;
    for (let i = 0; i < bands.length; i++) {
      const range = bands[i][key];
      if (!range) return null;
      if (value <= range.max) return i;
    }
    return bands.length;
  }

  class VmShapewearFinder {
    constructor(root) {
      this.root = root;
      this.panel = root.querySelector('[data-vm-panel]');
      this.form = root.querySelector('[data-vm-shapefinder]');
      this.result = root.querySelector('[data-vm-result]');
      this.config = JSON.parse(root.querySelector('[data-vm-shapefinder-config]').textContent);

      // The translate filter HTML-escapes, so an apostrophe arrives as &#39; and
      // would render literally through textContent. Decode once, via a textarea,
      // which parses entities without executing markup.
      const holder = document.createElement('textarea');
      Object.keys(this.config.strings).forEach((key) => {
        holder.innerHTML = this.config.strings[key];
        this.config.strings[key] = holder.value;
      });

      this.garments = Array.from(root.querySelectorAll('[data-vm-garment]')).map((el) => ({
        el: el,
        basis: el.getAttribute('data-vm-basis') || 'waist',
        source: el.getAttribute('data-vm-source') || 'product',
        bands: parseBands(el.getAttribute('data-vm-bands')),
        variants: parseVariants(el.getAttribute('data-vm-variants')),
        url: el.getAttribute('data-vm-url') || '',
      }));

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.find();
      });
      const restart = root.querySelector('[data-vm-restart]');
      if (restart) restart.addEventListener('click', () => this.reset());
    }

    get unit() {
      const checked = this.form.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : 'in';
    }

    // Bands are stored in inches because that is how both makers publish them.
    // Everything shown back to her is in the unit she picked. Two inch labels,
    // because "a 26 to 32 inch waist" and "starts at 26 inches" both have to read.
    show(inches) {
      if (this.unit === 'cm') return Math.round(inches * 2.54) + ' ' + this.config.strings.cm;
      return this.round(inches) + ' ' + this.config.strings.inchesPlural;
    }

    showRange(range) {
      if (this.unit === 'cm') {
        return Math.round(range.min * 2.54) + ' to ' + Math.round(range.max * 2.54) + ' ' + this.config.strings.cm;
      }
      return this.round(range.min) + ' to ' + this.round(range.max) + ' ' + this.config.strings.inches;
    }

    round(value) {
      return String(Math.round(value * 10) / 10);
    }

    // "a 26 to 32 inch waist", or both dimensions when the garment uses the hip.
    // One phrase, so the size she is offered and the size she is past are
    // described the same way.
    coverage(band, usesHip) {
      if (usesHip && band.hip) {
        return this.article(
          this.config.strings.coverageWaistHip
            .replace('[waist]', this.showRange(band.waist))
            .replace('[hip]', this.showRange(band.hip))
        );
      }
      return this.article(
        this.config.strings.coverageWaist.replace('[waist]', this.showRange(band.waist))
      );
    }

    // The article follows how the number is said, so centimetres bring "an 84"
    // and "an 11" while inches stay on "a 26".
    article(text) {
      return text.replace(/\ba (?=(8\d*|11|18)\b)/g, 'an ');
    }

    fail(message) {
      const error = this.root.querySelector('[data-vm-error]');
      error.textContent = message;
      error.hidden = false;
      this.result.hidden = true;
      this.panel.classList.remove('is-resolved');
    }

    reset() {
      this.form.reset();
      this.result.hidden = true;
      this.root.querySelector('[data-vm-error]').hidden = true;
      this.panel.classList.remove('is-resolved');
      this.panel.scrollIntoView({
        block: 'start',
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
      const first = this.form.querySelector('[data-vm-waist]');
      if (first) first.focus({ preventScroll: true });
    }

    // On the mobile layout the form is hidden once there is a result, which
    // shortens the page and leaves scroll anchoring to pick a position. Put the
    // panel back at the top of the viewport deliberately instead.
    settleScroll() {
      if (getComputedStyle(this.form).display !== 'none') return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.panel.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
    }

    find() {
      const strings = this.config.strings;
      const toInches = (value) => (this.unit === 'cm' ? value / 2.54 : value);
      const waistRaw = parseFloat(this.form.querySelector('[data-vm-waist]').value);
      const hipRaw = parseFloat(this.form.querySelector('[data-vm-hip]').value);

      if (!isFinite(waistRaw) || !isFinite(hipRaw) || waistRaw <= 0 || hipRaw <= 0) {
        this.fail(strings.errorMissing);
        return;
      }

      const waist = toInches(waistRaw);
      const hip = toInches(hipRaw);

      // Guards against cm typed while inches is selected, and the reverse.
      if (waist < 20 || waist > 70 || hip < 24 || hip > 80) {
        this.fail(strings.errorRange);
        return;
      }

      const longTorso = this.form.querySelector('[data-vm-torso]').checked;
      this.root.querySelector('[data-vm-error]').hidden = true;
      this.garments.forEach((garment) => this.renderGarment(garment, waist, hip, longTorso));

      this.result.hidden = false;
      this.panel.classList.add('is-resolved');
      this.settleScroll();
    }

    renderGarment(garment, waist, hip, longTorso) {
      const strings = this.config.strings;
      const bands = garment.bands;
      const size = garment.el.querySelector('[data-vm-size]');
      const range = garment.el.querySelector('[data-vm-range]');
      const reason = garment.el.querySelector('[data-vm-reason]');
      const cta = garment.el.querySelector('[data-vm-cta]');

      range.textContent = '';
      reason.textContent = '';
      garment.el.classList.remove('is-unsized');

      if (!bands.length) {
        size.textContent = '';
        return;
      }

      const usesHip = garment.basis === 'waist_hip' && bands.every((band) => band.hip);
      const waistIndex = indexFor(bands, waist, 'waist');
      const hipIndex = usesHip ? indexFor(bands, hip, 'hip') : null;

      // The garment has to travel over the widest point and then sit there, so
      // when the two measurements disagree the larger row is the one that fits.
      let index = waistIndex;
      let decidedBy = 'waist';
      if (hipIndex !== null && hipIndex > waistIndex) {
        index = hipIndex;
        decidedBy = 'hip';
      } else if (hipIndex !== null && hipIndex === waistIndex) {
        decidedBy = 'agree';
      }

      const smallest = bands[0];
      const largest = bands[bands.length - 1];

      // Past the top row: say so rather than sell a size that will roll.
      if (index >= bands.length) {
        garment.el.classList.add('is-unsized');
        size.textContent = strings.beyond.replace('[coverage]', this.coverage(largest, usesHip));
        cta.textContent = strings.ctaGuide;
        cta.href = garment.url;
        return;
      }

      const band = bands[index];
      const below = waist < smallest.waist.min && (!usesHip || hip < smallest.hip.min);

      // Close to the next row up on every measurement the garment is sized by.
      // Waist alone is not enough: a hip sitting mid-row means the size above is
      // cut for a hip she does not have, so nudging her up would be wrong.
      const next = bands[index + 1];
      const nearOnWaist = Boolean(next) && next.waist.min - waist <= 1;
      const nearOnHip = !usesHip || !next || !next.hip || next.hip.min - hip <= 1;
      const borderline = Boolean(next) && nearOnWaist && nearOnHip;
      // A tie is where torso length earns its say: bodysuits that already run
      // short on her push it over.
      const bumped = borderline && longTorso;

      const chosen = bumped ? next : band;
      size.textContent = chosen.label;
      range.textContent = strings.range.replace('[coverage]', this.coverage(chosen, usesHip));

      const lines = [];
      if (below) {
        lines.push(strings.below.replace('[min]', this.show(smallest.waist.min)).replace('[size]', chosen.label));
      } else if (bumped) {
        lines.push(strings.torsoBump.replace('[size]', chosen.label));
      } else {
        if (decidedBy === 'hip') lines.push(strings.reasonHip);
        else if (decidedBy === 'agree') lines.push(strings.reasonAgree);
        else lines.push(strings.reasonWaist);
        if (borderline) lines.push(strings.borderline.replace('[next]', next.label));
      }
      if (garment.source === 'guide') lines.push(strings.sourceGuide);
      reason.textContent = lines.join(' ');

      const variantId = garment.variants[String(chosen.label).toUpperCase()];
      cta.textContent = strings.cta;
      cta.href = variantId ? garment.url + '?variant=' + variantId : garment.url;
    }
  }

  document.querySelectorAll('.vm-shapefinder').forEach((root) => new VmShapewearFinder(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velomora-size-converter"] && !Shopify.designMode) return;
  try {
    
  // Same body, four labels. The Indian cup index i (A at a zero-inch
  // difference, per the bra calculator) is the shared axis: the config arrays
  // hold what that body is called in each system at the same i. International
  // cups A to C sit below Indian A, so their value is i - 3 and negative
  // values clamp to A, flagged as rough in the result.
  const VM_CUPS_BELOW = ['A', 'B', 'C'];

  class VmSizeConverter {
    constructor(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-vm-sizeconv-config]').textContent);
      this.systemSelect = root.querySelector('[data-vm-system]');
      this.bandSelect = root.querySelector('[data-vm-band-select]');
      this.cupSelect = root.querySelector('[data-vm-cup-select]');

      const range = (from, to, step) => {
        const out = [];
        for (let value = from; value <= to; value += step) out.push(value);
        return out;
      };

      // defBand keeps the same body selected across system switches:
      // India 34 = UK/US 30 = EU 65, and cup value 1 is B/DD/DD/E.
      this.systems = {
        india: { bands: range(30, 44, 2), cups: this.config.cups.in, base: 0, defBand: 34 },
        uk: { bands: range(26, 40, 2), cups: VM_CUPS_BELOW.concat(this.config.cups.uk), base: -3, defBand: 30 },
        us: { bands: range(26, 40, 2), cups: VM_CUPS_BELOW.concat(this.config.cups.us), base: -3, defBand: 30 },
        eu: { bands: range(55, 90, 5), cups: VM_CUPS_BELOW.concat(this.config.cups.eu), base: -3, defBand: 65 },
      };

      this.systemSelect.addEventListener('change', () => {
        this.populate();
        this.convert();
      });
      this.bandSelect.addEventListener('change', () => this.convert());
      this.cupSelect.addEventListener('change', () => this.convert());

      this.populate();
      this.convert();
    }

    populate() {
      const system = this.systems[this.systemSelect.value];
      this.bandSelect.textContent = '';
      system.bands.forEach((band) => {
        const option = document.createElement('option');
        option.value = String(band);
        option.textContent = String(band);
        this.bandSelect.appendChild(option);
      });
      this.bandSelect.value = String(system.defBand);

      this.cupSelect.textContent = '';
      system.cups.forEach((cup, index) => {
        const option = document.createElement('option');
        option.value = String(index + system.base);
        option.textContent = cup;
        this.cupSelect.appendChild(option);
      });
      this.cupSelect.value = '1';
    }

    convert() {
      const systemKey = this.systemSelect.value;
      const band = parseInt(this.bandSelect.value, 10);
      const i = parseInt(this.cupSelect.value, 10);
      if (!isFinite(band) || !isFinite(i)) return;

      let ukBand;
      if (systemKey === 'india') ukBand = band - 4;
      else if (systemKey === 'eu') ukBand = ((band - 55) / 5) * 2 + 26;
      else ukBand = band;

      const inBand = ukBand + 4;
      const euBand = ((ukBand - 26) * 5) / 2 + 55;
      const clamped = i < 0;
      const j = clamped ? 0 : i;
      const cups = this.config.cups;

      this.root.querySelector('[data-vm-size]').textContent = `${inBand}${cups.in[j]}`;
      this.root.querySelector('[data-vm-eq="uk"]').textContent = `${ukBand}${cups.uk[j]}`;
      this.root.querySelector('[data-vm-eq="us"]').textContent = `${ukBand}${cups.us[j]}`;
      this.root.querySelector('[data-vm-eq="eu"]').textContent = `${euBand}${cups.eu[j]}`;

      // A clamped result would echo the wrong cup back for the system the
      // visitor just picked, so the equivalents row goes away with it.
      this.root.querySelector('[data-vm-equivalents]').hidden = clamped;
      this.root.querySelector('[data-vm-note]').hidden = !clamped;

      // 30A to 40D is the stocked grid where every size maps to a variant.
      const stocked = inBand >= 30 && inBand <= 40 && j <= 3;
      this.root.querySelector('[data-vm-shop]').hidden = clamped || !stocked;

      this.root.querySelector('[data-vm-result]').hidden = false;
    }
  }

  document.querySelectorAll('.vm-sizeconv').forEach((root) => new VmSizeConverter(root));

  } catch(e) { console.error(e); }
})();
})();
